import React from 'react';

function News() {
  return (
    <main className="news">
      <section className="jumbotron text-center">
        <div className="container">
          <h1 className="jumbotron-heading">Nyheder</h1>
          <p className="lead text-muted">Alle nyhederne</p>
        </div>
      </section>
    </main>
  );
}

export default News;
